import AccountingInfoOption from './AccountingInfoOption';

export default class CapitalConnection extends AccountingInfoOption {
    public static entity = 'capitalConnections';
    public static apiType = 'capital-connections';
    public static storageKey = 'capital_connections_list';
}
